export default __webpack_public_path__ + "static/media/lg_arbitrum.869d8f1d.svg";